export default {
  title: '{{title}}',
  termsUseTitle: 'Conditions d’utilisation générales',
  protectionInfoTitle: 'Protection des renseignements personnels',
  contentTable: 'Table des matières',
};
